// Тестовые данные коллекций для разработки (как на макете)
export const mockCollections = [
  {
    id: 1,
    handle: 'salmon',
    title: 'Salmon',
    products_count: 12,
    image: {
      src: 'https://images.unsplash.com/photo-1544943142-2c4ea52fb2d8?w=300&h=200&fit=crop'
    },
    subcategories: ['Grouper', 'Swordfish', 'Halibut', 'Tuna', 'Sale']
  },
  {
    id: 2,
    handle: 'tuna',
    title: 'Tuna',
    products_count: 8,
    image: {
      src: 'https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=300&h=200&fit=crop'
    },
    subcategories: ['Swordfish', 'Salmon', 'Grouper', 'Sale', 'Halibut']
  },
  {
    id: 3,
    handle: 'halibut',
    title: 'Halibut',
    products_count: 15,
    image: {
      src: 'https://images.unsplash.com/photo-1544964122-1760798e8a15?w=300&h=200&fit=crop'
    },
    subcategories: ['Sale', 'Tuna', 'Swordfish', 'Salmon', 'Grouper']
  },
  {
    id: 4,
    handle: 'swordfish',
    title: 'Swordfish',
    products_count: 6,
    image: {
      src: 'https://images.unsplash.com/photo-1574781330855-d0db2906cee0?w=300&h=200&fit=crop'
    },
    subcategories: ['Salmon', 'Halibut', 'Tuna', 'Grouper', 'Sale']
  }
];